import * as React from "react";
import { Link, NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { IUploads } from "../interfaces";
import CoreComponent from "./CoreComponent";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { arrayToFormData } from "../utils/functions";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import TransactionModal from "../components/TransactionModal";

interface IState {
    models: IUploads[],
    limit: number,
    pagination: any,
    type: string,
    sort: string,
    isLoading: boolean,
    isOpen: boolean,
    currentPage: number,
}

class Reports extends CoreComponent<any, IState> {
    state: IState = {
        models: [],
        limit: 30,
        pagination: null,
        type: "",
        sort: "",
        isLoading: true,
        isOpen: false,
        currentPage: 1,
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    async componentWillMount() {
        this.loadObjects();
    }

    async loadObjects() {
        this.setState({
            isLoading: true,
        }, async () => {
            let url = null;
            let limit = this.state.limit * this.state.currentPage;

            url = `${config.api}/uploads?limit=${limit}`;

            if (this.state.sort) {
                url += `&sort=${this.state.sort}`;
            }

            if (this.state.type) {
                url += `&type=${this.state.type}`;
            }

            let res = await Axios.get(url);

            if (!this.isUnmounted) {
                this.setState({
                    models: res.data.models,
                    pagination: res.data.pagination,
                    isLoading: false
                })
            }
        })
    }

    setOrder(sort: string) {
        this.setState({
            type: this.state.sort != sort ? "asc" : (this.state.type == "asc" ? "desc" : "asc"),
            sort
        }, () => {
            this.loadObjects();
        });
    }

    showMore() {
        this.setState({
            currentPage: this.state.currentPage + 1
        }, () => {
            this.loadObjects();
        });
    }

    async delete(id: number) {
        if (confirm("Вы уверены?")) {
            let response: AxiosResponse = await Axios.post(`${config.api}/uploads/delete`, arrayToFormData({ id }));

            if (response.data && response.data.status == "success") {
                this.setState({
                    models: this.state.models.filter((object: IUploads) => object.id != id),
                });

                toast("Отчёт удалён.", { type: "success" });
            } else {
                toast("Ошибка сервера", { type: "error" });
            }
        }
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        }, () => {
            this.loadObjects();
        });
    }

    async download(filename: string) {
        let response: AxiosResponse = await Axios.get(`${config.api}/uploads/download?filename=${filename}`, { responseType: "blob" });

        const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        const link = document.createElement('a');

        link.href = url;

        let parts = filename.replace("_", ".").split(".");
        let download = parts.length == 3 ? parts[0] + "." + parts[parts.length - 1] : filename;


        link.setAttribute('download', download); //or any other extension

        document.body.appendChild(link);

        link.click();
        link.remove();
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-menu">
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>

                    <span className="crm-holders__title">Отчеты</span>

                    <div className="crm-requests">
                        <div className="tabs">
                            <div className="tabs-header" style={{ justifyContent: "flex-start" }}>
                                <NavLink to="/admin/reports">
                                    <div className="tabs-header__item border-line mr-5">
                                        Отчеты
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/reports/payment">
                                    <div className="tabs-header__item mr-5">
                                        Выплаты
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/reports/saved">
                                    <div className="tabs-header__item mr-5">
                                        Сохраненные оплаты
                                    </div>
                                </NavLink>
                                <NavLink to="/admin/reports/dopdoxod">
                                    <div className="tabs-header__item">
                                        Доп. доходы
                                    </div>
                                </NavLink>
                            </div>

                            <div className="tabs-content">
                                <div className="tabs-content__item active js-tab-content">
                                    <div
                                        className="tabs-content-items"
                                        style={{ display: "flex" }}
                                    >
                                        <div className="crm-list">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("created_at");
                                                            }}>
                                                                Дата
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("filename");
                                                            }}>
                                                                Файл
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("user");
                                                            }}>
                                                                Пользователь
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("views_count");
                                                            }}>
                                                                Кол-во отчёта
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("compositions_count");
                                                            }}>
                                                                Кол-во композиций
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button" onClick={() => {
                                                                this.setOrder("users_count");
                                                            }}>
                                                                Кол-во правообл.
                                                            <img src="img/Group 199.svg" alt="" />
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button">
                                                                Скачать
                                                            </a>
                                                        </th>
                                                        <th>
                                                            <a role="button">
                                                                Удаление
                                                            </a>
                                                        </th>
                                                    </tr>


                                                </thead>
                                                <tbody>
                                                    {!this.state.isLoading && this.state.models.length == 0 && <tr><td colSpan={11}>{t("Ничего не найдено")}</td></tr>}
                                                    {this.state.isLoading && <tr><td colSpan={11}>{t("Загрузка данных")}</td></tr>}
                                                    {this.state.models.map((object: IUploads, i: number) => {
                                                        let parts = object.filename.replace("_", ".").split(".");
                                                        let filename = parts.length == 3 ? parts[0] + "." + parts[parts.length - 1] : object.filename;

                                                        return <tr key={i}>
                                                            <td>{object.created_at}</td>
                                                            <td>{filename}</td>
                                                            <td>{object.user?.full_name}</td>
                                                            <td>{object.views_count}</td>
                                                            <td>{object.compositions_count}</td>
                                                            <td>{object.users_count}</td>
                                                            <td>
                                                                <a role="button" onClick={() => this.download(object.filename)}><i className="fa fa-download"></i></a>
                                                            </td>
                                                            <td>
                                                                <a role="button" onClick={() => {
                                                                    this.delete(object.id);
                                                                }}><img className="text-white" src="img/Icon awesome-trash.svg " alt=" " /></a>
                                                            </td>
                                                        </tr>;
                                                    })}
                                                </tbody>
                                            </table>
                                            <div className="text-center p-3">
                                                {this.state.models.length > 0 && this.state.models.length < (this.state.pagination?.totalCount) && <a role="button" className="spec-color fs-12" onClick={() => {
                                                    this.showMore();
                                                }}>Показать ещё...</a>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(Reports));
